import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this.observer = new MutationObserver(() => this.arm())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.timer)
  }

  arm() {
    clearTimeout(this.timer)
    const currentId = this.element.dataset.currentUserId
    if (currentId) {
      this.element.querySelectorAll(`[data-typer-id="${currentId}"]`).forEach((node) => node.remove())
    }
    if (!this.element.innerHTML.trim()) return

    this.timer = setTimeout(() => { this.element.innerHTML = "" }, this.timeoutValue)
  }
}
